/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Layers, SerialLayers} from "../view/SerialLayers";
import {Serial} from "../Serial";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SerialSound} from "../sound/SerialSound";
import {gsap} from "gsap";

export class FreespinOutro extends ContinueScreen {

    // private _played:PIXI.Text;
    private _image:PIXI.Sprite;

    constructor() {
        super(SerialLayers.getLayer(Layers.SCREENS)!);

        this._image = new PIXI.Sprite();
        this._image.anchor.set(0.5);
        this._image.position.set(360, 360);
        this._image.alpha = 0;
        this._container.addChild(this._image);

        // this._played = new PIXI.Text("", new PIXI.TextStyle({
        //     dropShadow : true,
        //     dropShadowBlur : 2,
        //     dropShadowDistance : 2,
        //     fill : 0xff0000,
        //     fontFamily : OpenSans.FAMILY,
        //     fontWeight : FontWeight.BOLD,
        //     lineJoin : "round",
        //     fontSize : 36,
        //     wordWrap : false,
        // }));
        // this._played.anchor.set(0.5, 0.5);
        // this._played.position.set(360, 580);
        // this._container.addChild(this._played);
    }

    public show(onContinueCallBack:() => void) {
        const belowStakeWinRestriction = BelowStakeWinRestriction.isWinBelowStake();
        SlotGame.keypadPlugin.setWin(Serial.model.parsedGameData.totalWin, true, belowStakeWinRestriction);
        SlotGame.keypadPlugin.hide();
        Serial.jumpingScatterController.finish();
        // this._played.visible = false;

        if(belowStakeWinRestriction) {
            //TODO: DO NOT play sound and count up, show end number directly.
        }

        const noWin = Serial.model.parsedGameData.totalWin === 0 || belowStakeWinRestriction;
        // const spinPlayed = Serial.model.parsedGameData.numberOfFreespinsPlayed;
        // this._played.text = `${spinPlayed} ${Translation.translation(`SPIN${spinPlayed === 1 ? "" : "S"}`)}`;
        // this._played.y = Serial.model.data.mode.includes("SUPER") ? 360 : 580;
        // this._played.style.fill = Serial.model.data.mode.includes("SUPER") ? 0xe8e002 : 0xae00ff;
        this._image.texture = Serial.assetLoader.getTextures(
            Serial.model.data.mode.includes("SUPER") ? "freespin/Super_FS_outro" : `freespin/FS_outro_${noWin ? "lose" : "win"}`
        )[0];
        const tl = gsap.timeline();
        tl.add([
            Serial.background.tweenDimmer(0.8, 0.4),
            gsap.to(this._image, {alpha : 1, duration : 0.6}),
            Serial.screenCountUp.getCountUpAnimation(0, Serial.model.parsedGameData.totalWin, noWin ? 0.01 : 2, SerialLayers.getLayer(Layers.SCREENS)!, 100),
            () => {
                this.visible = true;
                SerialSound.fadeMusic(0, 1);
                SerialSound.soundPlayer.playTrack({name : SerialSound.FS_OUTRO});
                if(!noWin) {
                    SerialSound.soundPlayer.playTrack({name : SerialSound.FS_OUTRO_COUNTUP, repeat : 1000});
                    SerialSound.PLAYING_LOOP_EFFECT = SerialSound.FS_OUTRO_COUNTUP;
                } else {
                    SerialSound.soundPlayer.playTrack({name : SerialSound.FS_OUTRO_COUNTUP_END});
                }
            }
        ]);
        if(!noWin) {
            tl.add(() => {
                SerialSound.soundPlayer.playTrack({name : SerialSound.FS_OUTRO_COUNTUP_END});
                SerialSound.PLAYING_LOOP_EFFECT = "";
                SerialSound.soundPlayer.stopTrack(SerialSound.FS_OUTRO_COUNTUP);
            }, 2);
        }

        tl.add(() => {
            // this._played.visible = true;
            super.show(onContinueCallBack);
        });
    }

    protected close():gsap.core.Timeline {
        const tl = super.close();
        tl.add(() => {
            const feature = Serial.apiPlugin.betFeatureController.getActiveBetFeature();
            SerialSound.soundPlayer.playTrack({
                name :
                    feature != undefined && feature.name != Serial.xBetController.boostedName ?
                        SerialSound.CONTINUE_FS_OUTRO_BONUS_BUY : SerialSound.CONTINUE_FS_OUTRO
            });
            this.startNormalMusic();
            Serial.screenCountUp.remove();
        }, 0);
        tl.add([
                () => {
                    Serial.background.tweenDimmer(0, 0.1);
                    Serial.background.setMode(GameMode.NORMAL);
                    this._image.alpha = 0;
                }
            ]
        );
        return tl;
    }

    private startNormalMusic():void {
        SerialSound.switchMusic({
            name : SerialSound.MAIN_GAME_MUSIC,
            volume : 1
        });
    }
}